
import { useBidTypes, useTenderCategories } from "@/lib/api/hooks/tender";
import type { FilterSection } from "@/types/filterTypes";
import { useMemo } from "react";
    
export const useTendersFilterSections = (): FilterSection[] => {

const { data: bidTypesData, isFetching: isFetchingBidTypes, isError: isErrorBidTypes, refetch: refetchBidTypes } = useBidTypes();
  const { data: tenderCategoriesData, isFetching: isFetchingTenderCategories, isError: isErrorTenderCategories, refetch: refetchTenderCategories } = useTenderCategories();

    const bidTypeOptions = useMemo(
      () =>
        (bidTypesData?.data ?? []).map((type: { value: string; displayName: string }) => ({
          value: type.value,
          label: type.displayName
        })),
      [bidTypesData?.data]
    );
  
    const tenderCategoryOptions = useMemo(
      () =>
        (tenderCategoriesData?.data ?? []).map((category: { value: string; displayName: string }) => ({
          value: category.value,
          label: category.displayName
        })),
      [tenderCategoriesData?.data]
    );
  
    
  return [
    {
      key: "bidType",
      label: "Bid Type",
      type: "select",
      options: bidTypeOptions,
      isFetching: isFetchingBidTypes,
      isError: isErrorBidTypes,
      refetch: refetchBidTypes
    },
    {
      key: "tenderCategory",
      label: "Tender Category",
      type: "select",
      options: tenderCategoryOptions,
      isFetching: isFetchingTenderCategories,
      isError: isErrorTenderCategories,
      refetch: refetchTenderCategories
    },
    {
      key: "searchBy",
      label: "Search",
      type: "text",
    },
    {
      key: "closingSoon",
      label: "Is Closing Soon?",
      type: "boolean",
    },
    {
      key: "isExpired",
      label: "Is Expired?",
      type: "boolean",
    },
    {
      key: "deadLineStartDate",
      label: "Deadline Start Date",
      type: "date",
    },
    {
      key: "deadLineEndDate",
      label: "Deadline End Date",
      type: "date",
    },
    {
      key: "createdStartDate",
      label: "Created At Start Date",
      type: "date",
      placeholder: "From"
    },
    {
      key: "createdEndDate",
      label: "Created At End Date",
      type: "date",
      placeholder: "To"
    },
    {
      key: "publishedStartDate",
      label: "Published At Start Date",
      type: "date",
      placeholder: "From"
    },
    {
      key: "publishedEndDate",
      label: "Published At End Date",
      type: "date",
      placeholder: "To"
    }
  ];
};
